// https://www.symbolspy.com/dot-symbol.html

const prepare_ai_future = 
`☼ Please add:

    • anything (e.g., terms, concepts, themes, perspectives, arguments, issues) you know about the impact of AI on the future of work

    • questions you would be interested in exploring

See below ▼ for examples.
`;

const prepare_global_warming = 
`☼ Please add:

    • anything (e.g., terms, concepts, themes, perspectives, arguments, issues) you know about the impact of global warming on the economy

    • questions you would be interested in exploring

See below ▼ for examples.
`;


const future_of_work = 
`Imagine you are giving a talk on the following topic in two weeks:

► Impact of AI on the Future of Work: Advances in artificial intelligence such as large language models, generative AI models, etc. have the potential to change how we work. They can dramatically improve the efficiency of our workplaces and can augment the work humans can do. But also make some jobs redundant. 

Before the talk, you are meeting your colleagues to plan the talk together.

In your meeting with colleagues, you are expected to share an overview of this topic, its high-level concepts / questions / themes / etc. 

You will use this tool to share your findings, so you should organize them appropriately.

=========================================================

To get you started, some things you can explore include, but not limited to:  

• advances in AI technology that could affect the future of work, 

• the technological, environmental, societal, and economic factors that might affect these decisions and

• potential alternative solutions to this evolving problem. 

=========================================================

Your goal should be to: 

☐ identify as many terms, concepts, themes, perspectives, and questions related to the topic 

☐ organize the information in a way that would help your colleagues easily make sense of it.`;

const global_warming = 
`Suppose you are giving a talk on the following topic in two weeks:

► Impact of Global Warming on the Economy: Climate change refers to long-term shifts in temperatures and weather patterns. These have more recently been aggravated by humans, and can affect our society and economy in various ways.  

Before the talk, you are meeting your colleagues next week to plan the talk together.

In your meeting with colleagues, you are expected to share an overview of this topic, its high-level concepts / questions / themes / etc. 

You will use this tool to share your findings, so you should organize them appropriately.

=========================================================

To get you started, some things you can explore include, but not limited to:  

• causes of global warming as well as its growing impact

• the technological, societal, environmental and economic factors that might affect this issue, and 

• potential solutions to this evolving issue. 

=========================================================

Your goal should be to: 

☐ identify as many terms, concepts, themes, perspectives, and questions related to the topic 

☐ organize the information in a way that would help your colleagues easily make sense of it.`;

const example = `Suppose you are giving a talk on the following topic in two weeks:

► Economic inequality: The distribution of wealth and resources within and between countries is a major source of social and political tensions, as well as a barrier to social mobility and economic growth.

Before the talk, you are meeting your colleagues next week to plan the talk together.

In your meeting with colleagues, you are expected to share an overview of this topic, its high-level concepts / questions / themes / etc. 

You will use this tool to share your findings, so you should organize them appropriately.

»»» To get you started, some things you can explore include, but not limited to:  

• causes of economic inequality as well as its growing impact

• the technological, societal, environmental and economic factors that might affect this issue, and 

• potential solutions to this evolving issue. 

»»» Your goal should be to: 

☐ identify as many terms, concepts, themes, perspectives, and questions related to the topic 

☐ organize the information in a way that would help your colleagues easily make sense of it.`;

const tutorial_baseline = `This is a very similar tool to the very first tool you used. 

You can add ✎, edit ✄, connect ⇆, and group ⋃ nodes like you did in the pre-study on the right-hand side. 

The difference is that it just has a ChatGPT question answering chatbot on the left-hand-side ◫. 

Treat this chat box as if you were talking to a human. It can help answer questions across different fields and types of questions from answering what fruit is the healthiest? to writing an essay ☰ on the farming of fruits. 

Unlike most chatbots, ChatGPT remembers previous prompts given to it in the same conversation. 

⋇ However, note that answers can be incorrect or nonsensical. Now, try asking a question about fruits and practice taking notes on this canvas.`

const tutorial_sensecape = `This tool adds Hierarchy View ⇵▱ to the canvas view ▢.

    ↳ Hierarchy View helps you better structure your exploration and notes while reducing the visual clutter that tends to happen when you just have a single canvas. 

☐ To use Hierarchy View, press 'H' ⌨ or click Hierarchy View button (bottom left)
 
In Hierarchy View ⇵▱,

    ☐ To add ⇡ higher or ⇣ lower level topics, click 'Broad Topic' or 'Custom Topic' / 
        'Generated Subtopic'

    ☐ To delete ✄ canvas layer, hover over canvas ➡ click ☓ 

===================================================

☐ To dive in ⤵ / out ⤴, double click on node 

☐ To filter information and view it at different levels of granularity, 
    ↳ select 'All', 'Line', 'Summary', 'Keywords' or 'Auto'

☐ To use ___ in node as prompt, click node ➡ select 'Prompt' button 

☐ To learn about ___ in node , click node ➡ select 'Explain' button 

☐ To generate questions on ___  in node, click node ➡ select 'Questions' button

☐ To generate subtopics of ___ in node, click node ➡ select 'Subtopics' button

⋇ Note that answers can be incorrect or nonsensical sometimes. Now, try exploring, asking questions and generating subtopics in this canvas.
`;

const demo_sensecape = `Sensecape is a platform that enables the user to nonlinearly explore information generated by GPT-4 and sensemake in a multilevel hierarchical structure.

☐ To create a new node, double click on the canvas. 'Shift'+'Enter' to automatically prompt, 'Enter' to save the text.

☐ To use ___ in node as prompt, click node ➡ select 'Prompt' button 

☐ To learn about ___ in node , click node ➡ select 'Explain' button 

☐ To generate questions on ___  in node, click node ➡ select 'Questions' button

☐ To generate subtopics of ___ in node, click node ➡ select 'Subtopics' button

☐ To filter information and view it at different levels of granularity, 
    ↳ select 'All', 'Line', 'Summary', 'Keywords' or 'Auto'

☐ To dive in ⤵ / out ⤴, double click on node 

⋇ Note that answers can be incorrect or nonsensical sometimes. Now, try exploring, asking questions and generating subtopics in this canvas.

===================================================

↳ Hierarchy View helps you better structure your exploration and notes while reducing the visual clutter that tends to happen when you just have a single canvas. 

☐ To use Hierarchy View, press 'H' ⌨ or click Hierarchy View button (bottom left)
 
In Hierarchy View ⇵▱,

    ☐ To add ⇡ higher or ⇣ lower level topics, click 'Broad Topic' or 'Custom Topic' / 
        'Generated Subtopic'

    ☐ To delete ✄ canvas layer, hover over canvas ➡ click ☓ 

`;

export { prepare_ai_future, prepare_global_warming, global_warming, future_of_work, example, tutorial_baseline, tutorial_sensecape, demo_sensecape };